import React from 'react'
import { Link } from 'react-router-dom'

const CallAction = () => {
  return (
    <section
  className="call-to-action-two"
  style={{ backgroundImage: "url(/assets/images/background/5.png)" }}
>
  <div className="auto-container">
    <div className="row">
      <div className="content-column col-lg-6 offset-lg-6">
        <div className="content-box wow fadeInUp">
          <span className="sub-title">GET EXPERIENCE</span>
          <h2>Shift Your Perspective on Digital Business</h2>
          <span className="text">
            How you transform your business as technology, consumer, habits
            industry dynamic s change? Find out from those leading the charge.
          </span>
          <Link  to="buy-ticket.html" className="theme-btn btn-style-two">
            <span className="btn-title">Donate</span>
          </Link> 
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default CallAction